module.exports = __webpack_public_path__ + "static/media/campoCoronacion.758c46ce.jpg";